// extracted by mini-css-extract-plugin
export default {"m":"ProductListItem_m__8wfvC","flat":"ProductListItem_flat__Fd8+R","waved":"ProductListItem_waved__UZyJr"};